/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_List_NoteInputs */

const vi_shop_group_list_note = /** @type {(inputs: Shop_Group_List_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật/tắt Hiện web / Mini App ngay trên dòng; "Bán chạy" là thứ hạng nhập tay (trống = không vào khối Bán chạy). "Có sẵn hàng" đếm theo ô tick trên từng loại.`)
};

/**

* @param {Shop_Group_List_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_list_note = /** @type {((inputs?: Shop_Group_List_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_List_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_list_note(inputs)
});